module.exports = __webpack_public_path__ + "img/image-backdrop-blue.ad2906a8.svg";